export default {
  consumerEmpBoxesFlag: false,
  insuranceBoxFlag: false,
  personalizedFlag: false,
};
